import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'leap-form-guidance',
  templateUrl: './form-guidance.component.html',
  styleUrls: ['./form-guidance.component.less']
})
export class FormGuidanceComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
